<div class="stepper-horizontal">
  @for (step of steps(); track step) {
    <div class="step" [ngClass]="getStepClass($index)">
      <div class="step-item" [ngStyle]="getStepStyle($index)">
        @if (getStepClass($index) === "done") {
          <a style="font-size: 12px"><i class="fa fa-check"></i></a>
        }
        @if (getStepClass($index) !== "done") {
          <span style="font-weight: bold">{{ $index + 1 }}</span>
        }
      </div>
      @if (!useLocalization()) {
        <div class="step-title">{{ step }}</div>
      }
      @if (useLocalization()) {
        <div class="step-title">{{ "GAST-PORTAL-NG.WIZARD-STEPS-COMPONENT." + step | translate }}</div>
      }
      <div class="step-bar-left" [ngStyle]="getBarLeftStyle($index)"></div>
      <div class="step-bar-right" [ngStyle]="getBarRightStyle($index)"></div>
    </div>
  }
</div>
